/*eslint-disable */
import React, { useEffect, useState } from 'react'
import { Button, Dropdown, Modal, Radio } from 'semantic-ui-react'
import { withFormik, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi, Checkbox } from "semantic-ui-react";
import { MyNormalInput } from '../dynamicComponent/myInputs';
import { connect } from "react-redux";
import { AllRegex } from "../../utils/validation";
import UpdateAxios from '../axiosComponent/update';
import CreatAxios from '../axiosComponent/create';
import {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from 'react-i18next';
import { MESSAGES } from './common.constants';
import ReadAxios from '../axiosComponent/read';
import { FEATURES } from '../../utils/constant';
const UserEdit = ({ isSubmitting, handleSubmit, values, touched, errors, t, setFieldValue, editUser, CloseModal, editUserMode,isBusinessUnit, ...props }) => {

    useEffect(() => {
        getBusinessUnits()
      }, []);
    
      const getBusinessUnits = () => {
          ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/businessUnitMaster`, readItems: { module_name: "TA" } }).then((result) => {
            let dataArray =  result.data?.resultSet || [];
            let options = dataArray.map((item, index) => {
              return {
                key: index, 
                text: item.businessUnitName,
                value: item.businessUnitId,
                raw : item
              }
            })
            setBusinessUnitOptions(options)
          });
      };
    const [businessUnitOptions, setBusinessUnitOptions] = useState([])
    const checkForbussinessUnit = (name, data) => {
        setFieldValue("businessUnitId", data.value);
        let rawdata = businessUnitOptions.find((obj)=>obj.value === data.value)?.raw
        rawdata && setFieldValue("businessUnit", rawdata.businessUnitCode);
      }
    const changeWhatsAppConsent = (e,data)=>{
        let whatsAppConsent = data.checked
        setFieldValue("whatsAppConsent",whatsAppConsent)
    }

    return (
        <Modal
            onClose={CloseModal}
            open={editUser}
            size="small"
            className="p-overflow-initial"
        >
            <Modal.Header>{editUserMode ? t('edit_title') : t('add')} {t("title")}</Modal.Header>
            <Modal.Content>
                <div className="ui form small">
                    <FormUi.Group inline={errors.userName || errors.password ? false : true}>
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.user_name")}</label><span className="text-danger">*</span>
                        </FormUi.Field>
                        <FormUi.Field error={values.userName ? false : true} width="4">
                            <Fieldmik readOnly={editUserMode ? true : false} name="userName" component={MyNormalInput} />
                            {touched.userName && errors.userName ? <small className="text-danger">{errors.userName}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.password")}</label><span className="text-danger">*</span>
                        </FormUi.Field>
                        <FormUi.Field error={values.password ? false : true} width="4">
                            <Fieldmik name="password" type="password" component={MyNormalInput} />
                            {touched.password && errors.password ? <small className="text-danger">{errors.password}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group inline={errors.realName || errors.email ? false : true}>
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.name")}</label><span className="text-danger">*</span>
                        </FormUi.Field>
                        <FormUi.Field error={values.realName ? false : true} width="4">
                            <Fieldmik name="realName" component={MyNormalInput} />
                            {touched.realName && errors.realName ? <small className="text-danger">{errors.realName}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.email")}</label><span className="text-danger">*</span>
                        </FormUi.Field>
                        <FormUi.Field error={values.email ? false : true} width="4">
                            <Fieldmik name="email" component={MyNormalInput} />
                            {touched.email && errors.email ? <small className="text-danger">{errors.email}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group inline>
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.phone")}</label><span className="text-danger">*</span>
                        </FormUi.Field>
                        <FormUi.Field error={values.mobileNo ? false : true} width="4">
                            <Fieldmik maxLength="10" name="mobileNo" type="text" component={MyNormalInput} />
                            {touched.mobileNo && errors.mobileNo ? <small className="text-danger">{errors.mobileNo}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        {isBusinessUnit && <><FormUi.Field width="2">
                      <label className="labelName ">
                        {t("table_header.business_unit") || "Business Unit"}{" "}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width="4"
                      error={
                        touched.businessUnit && errors.businessUnit ? true : false
                      }
                    >
                      <Dropdown
                        name="businessUnit"
                        clearable
                        style={{ width: "100%", fontWeight: "normal" }}
                        selection
                        placeholder={
                          t("table_header.business_unit") || "Business unit"
                        }
                        onChange={(name, data) => checkForbussinessUnit(name, data)}
                        options={businessUnitOptions}
                        upward
                        value={values.businessUnitId}
                      />
                      {touched.businessUnit && errors.businessUnit ? (
                        <div>
                          {t(`create.businessUnit.error_msg.${errors.businessUnit}`) ||
                            errors.businessUnit}
                        </div>
                      ) : null}
                    </FormUi.Field>
                    </>}

                    {props.whatsappConsentField && FEATURES.whatsappConsentFieldEnabled() &&  !props?.editParams && 
                    <>
                    <FormUi.Field width="2">
                      <label className="labelName ">
                        {t("table_header.whatsapp_alert") || "Whatsapp Alert"}{" "}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width="4"
                    >
                      <Radio toggle 
                      name="whatsAppConsent"
                      checked={values.whatsAppConsent}
                      onChange={changeWhatsAppConsent}
                        />
                    </FormUi.Field>
                    </>}
                    </FormUi.Group>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color='green' size="mini" type='button' onClick={CloseModal}>
                    {t("cancel")}
                </Button>
                <Button type='submit' disabled={isSubmitting} onClick={handleSubmit} size="mini" color="blue">
                    {t("ok")}
                </Button>
            </Modal.Actions>
        </Modal>
    )
}
const FormikUserEdit = withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props, userName, realName, email, mobileNo, password, businessUnitId) => {
        // console.log(">>>", props.id)
        return {
            userName: (props.editParams ? props.editParams.userName : userName) || '',
            realName: (props.editParams ? props.editParams.realName : realName) || '',
            email: (props.editParams ? props.editParams.email : email) || '',
            mobileNo: (props.editParams ? props.editParams.mobileNo : mobileNo) || '',
            password: (props.editParams ? props.editParams.password : password) || '',
            businessUnitId: (props.editParams ? props.editParams.businessUnitId : businessUnitId) || '',
            consignorId: props.editUserMode || props.productName == 'consignor' ? props.id : '' || '',
            consigneeId: props.editUserMode || props.productName == 'consignee' ? props.id : '' || '',
            // vendorId: (props.editUserMode ? '' : props.productName == 'vendor' ? (props.editParams ? props.editParams.u_id : '') : props.id) || '',
            vendorId: props.editUserMode || props.productName == 'vendor' ? props.id : '' || '',
            billingPartyId: props.editUserMode || props.productName == 'billing_party' ? props.id : '' || '',
            whatsAppConsent : false
        }
    },
    validationSchema: yup.object({
        userName: yup.string().required(MESSAGES.required),
        realName: yup.string().required(MESSAGES.required),
        email: yup.string().email(MESSAGES.invalidEmail).required(MESSAGES.required),
        mobileNo: yup.string().matches(AllRegex.MobileNumber, MESSAGES.invalidMobileNumber).required(MESSAGES.required),
    }),
    async handleSubmit(values, { props }) {
        // console.log(values, props)
        // return
        if (props.editParams && props.editParams.u_id) {
            await UpdateAxios({
                url: `users/${props.productName}`,
                payload: { ...values, userKey: props.editParams.userKey },
                uniqueId: props.editParams.u_id,
            }).then((response) => {
                if (response.data.status === 204 || response.status === 204) {
                    let alert = {
                        type: "error",
                        messageHeader: "Error",
                        messageBody: response.data.message ? response.data.message : MESSAGES.updateUserFailed,
                    };
                    props.errorAlertDispatcher(alert);
                } else {
                    let alert = {
                        type: "success",
                        messageHeader: "Success",
                        messageBody: MESSAGES.updateUserSuccess,
                    };
                    props.closeEditUser(true)
                    window.location.reload()
                    props.successAlertDispatcher(alert);
                    props.onFormSubmit();
                }

            })
                .catch((err) => {
                    if (err.data.status === 204) {
                        let alert = {
                            type: "error",
                            messageHeader: "Error",
                            messageBody: `${MESSAGES.updateUserFailed}, ${err.data.message} `,
                        };
                        props.errorAlertDispatcher(alert);
                    }
                });
        } else {
            await CreatAxios({
                url: `users/${props.productName}`,
                payload: { ...values },
            })
                .then(async(res) => {
                    if (res?.data?.status === 204 || res?.status === 204) {
                        let alert = {
                            type: "error",
                            messageHeader: "Error",
                            messageBody: res?.data?.message ? res.data.message : MESSAGES.createUserFailed,
                        };
                        props.errorAlertDispatcher(alert);
                    } else {
                        if(FEATURES.whatsappConsentFieldEnabled() && values.whatsAppConsent){
                            await UpdateAxios({
                                url : `whatsappConsentStatus/${values.mobileNo}/1?userMasterId=${res.data.lastInsertedId}`
                            })
                        }
                        let alert = {
                            type: "success",
                            messageHeader: "Success",
                            messageBody: MESSAGES.createUserSuccess,
                        };
                        props.closeEditUser(true)
                        window.location.reload()
                        props.successAlertDispatcher(alert);
                        props.onFormSubmit();
                    }
                })
                .catch((err) => {
                    if (err?.data?.status === 204) {
                        let alert = {
                            type: "error",
                            messageHeader: "Error",
                            messageBody: err?.data?.message || err?.message || MESSAGES.createUserFailed,
                        };
                        props.errorAlertDispatcher(alert);
                    }

                });
        }
    }

})(UserEdit)
export default connect(null, {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
})(translate('user_table')(FormikUserEdit))
